'use strict';
var Backbone = require('backbone'),
  $ = require('jquery'),
  HereForTheHow = Backbone.View.extend({
    events: {
      'click .HereForTheHow--wrap-videoLink': 'methodToCallOnClick'
    },
    initialize: function() {
      this.$remodalPopup = $('.remodal')
      this.hasVideo = 'has-video'
      this.popup = '.HereForTheHowPopup'
      this.remodalClose = 'remodal-close'
      this.remodalOverlay = '.remodal-overlay'
      this.remodalOpen = 'remodal-is-opened'
      this.mouse = 'mouse'
      this.videoAppend = '.video-append'
      this.overLayVideo = 'overlay-video'
      this.embedMedia = '.embed_media'
      this.HereForTheHow = '.HereForTheHow'
      this.$classRemodalClose = $(this.popup).find('.remodal-close')
      this.$videoLink = this.$el.find('.HereForTheHow--wrap-videoLink')
      this.classvideoLink = 'HereForTheHow--wrap-videoLink'
      this.openPopupVideo()
      this.closePopupVideo()
      this.handleKeyDownADAPopup()
      $(window).on('load', () => {
        if (window.location.href.indexOf(`#${$(this.popup).attr('data-remodal-id')}`) > 0) {
          this.handleRenderIframeVideoPopup()
        }
        this.startFocus()
      })
    },
    methodToCallOnClick: function() {
      $(this.popup).remodal().open()
      $(this.remodalOverlay).addClass(this.overLayVideo)
      if (!$(this.popup).find(this.$classRemodalClose).hasClass(this.mouse)) {
        this.addClassOverlay()
      }
    },
    handleRenderIframeVideoPopup() {
      if ($(this.$remodalPopup).hasClass(this.hasVideo)) {
        if ($(this.popup).hasClass(this.remodalOpen)) {
          this.addClassOverlay()
        }
        let video = encodeURIComponent(this.$remodalPopup.find(this.embedMedia).attr('data-original'))
        let title = encodeURIComponent(this.$remodalPopup.find(this.embedMedia).attr('data-title'))
        if (!this.$remodalPopup.find(this.videoAppend).length) {
          this.$remodalPopup.find(this.embedMedia).append(`<iframe class="video-append" width="100%" height="100%" src="${decodeURIComponent(video)}" frameborder="0" title="${decodeURIComponent(title)}" tabindex="0" allowfullscreen></iframe>`)
        }
      }
    },
    openPopupVideo() {
      $(this.popup).attr('tabindex', '0')
      $(document).on('opening', () => {
        this.handleRenderIframeVideoPopup()
      })
    },
    closePopupVideo() {
      $(document).on('closed', () => {
        if (this.$remodalPopup.hasClass(this.hasVideo)) {
          this.$remodalPopup.find(this.videoAppend).remove()
          $(this.remodalOverlay).removeClass(this.overLayVideo)
          this.handleKeyBoardClosePopup()
        }
      })
    },
    addClassOverlay() {
      $(this.remodalOverlay).addClass(this.overLayVideo)
    },
    handleKeyBoardClosePopup() {
      if ($(document.activeElement).hasClass(this.remodalClose)) {
        setTimeout(()=> {
          $(this.$videoLink).focus()
        }, 100)
      }
    },
    handleKeyDownADAPopup() {
      $(`${this.popup},${this.HereForTheHow}`).on('keydown', (e) => {
        $('.remodal-close').removeClass(this.mouse)
        switch (e.key) {
          case 'Enter':
            if ($(document.activeElement).hasClass(this.classvideoLink)) {
              setTimeout(() => {
                $(this.$classRemodalClose).removeClass(this.mouse)
              }, 100);
            }
            break;
          case 'Escape':
            if ($(document.activeElement).hasClass('HereForTheHowPopup')) {
              $(this.$videoLink).focus()
            }
            break;
          case 'Tab':
            if (e.shiftKey) {
              if ($(document.activeElement).hasClass(this.remodalOpen)) {
                $(this.$classRemodalClose).focus()
                e.preventDefault()
              }
            } else {
              if ($(document.activeElement).hasClass(this.remodalClose)) {
                $(this.popup).focus()
                e.preventDefault()
              }
            }
            break;
          default: break;
        }
      })
    },
    startFocus() {
      if ($(this.popup).hasClass(this.remodalOpen)) {
        setTimeout(()=> {
          $(this.popup).focus()
        }, 100)
      }
    }
  }, {
    create: function create($parent) {
      $parent.find('.HereForTheHow').each((n, el) => {
        new HereForTheHow({
          el: el
        });
      });
    }
  });

module.exports = HereForTheHow;


// WEBPACK FOOTER //
// ./assets/components/HereForTheHow/HereForTheHow.js